<div class="mb-3" [class.invalid-feedback]="showError">
  @if (props.label && props.hideLabel !== true) {
    <label [attr.for]="id" class="label">
      {{ props.label }}
      @if (props.required && props.hideRequiredMarker !== true) {
        <span>*</span>
      }
    </label>
  }
  <div>
    <input nbInput
      [formControl]="formControl"
      [formlyAttributes]="field"
      fieldSize="small"
      />
  </div>
  @if (showError) {
    <div class="invalid-feedback">
      <formly-validation-message [field]="field" />
    </div>
  }
  @if (props.description) {
    <small class="form-text text-muted">{{ props.description }}</small>
  }
</div>
